<template>
  <div key="empty-search" class="empty-search">
    <img class="empty-search__img" src="img/provider-search__empty.webp" alt="no-result" />
    <h6 class="empty-search__title">{{ t('emptyGames') }}</h6>
    <p class="empty-search__description">{{ t('playGamesInCategoryes') }}</p>
    <div class="empty-search__links">
      <router-link
        v-for="item in mainGroups"
        :key="item.id"
        :to="{ name: item.name, params: { group: item.slug } }"
        class="empty-search__link"
      >
        {{ item.label }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMainStore } from 'src/stores/main'

const { t } = useI18n()
const mainGroups = computed(() => useMainStore().getMainGroups)
</script>

<style scoped lang="scss">
.empty-search {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 16px;

  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    color: rgba(255, 255, 255, 0.9);
    text-align: center;

    @media screen and (max-width: 767px) {
      max-width: 250px;
    }
  }

  &__img {
    width: 320px;
    margin-top: 24px;
  }

  &__description {
    font-size: 14px;
    line-height: 18px;
    margin-top: 16px;
    color: #fff;
  }

  &__links {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-width: 300px;
    justify-content: center;
    margin-top: 24px;
  }

  &__link {
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.1);
    transition: all 0.2s;
    text-decoration: none;
    color: white;
    border-radius: 100px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }
}
</style>
